export const Spacing = {
  None: 0 as const,
  Supermicro: 2 as const,
  Micro: 4 as const,
  Condensed: 8 as const,
  Tight: 12 as const,
  Compact: 16 as const,
  Cozy: 24 as const,
  Relaxed: 32 as const,
  Ample: 48 as const,
};
